const FAQS = [
  {
    question: 'When is monetization expanding beyond the U.S.?',
    answer:
      'Many campaigns have a set rate, depending on your audience and the brand in question. In most cases, you will know before you accept a campaign what the CPM is.',
  },
  {
    question: 'When do I know how much I’ll earn with each Anchor Ads option?',
    answer:
      'Many campaigns have a set rate, depending on your audience and the brand in question. In most cases, you will know before you accept a campaign what the CPM is.',
  },
  {
    question:
      "I'm not currently hosted on Anchor. Can I still use your monetization tools?",
    answer:
      'Your podcast must be hosted on Anchor to take advantage of Anchor’s monetization tools.',
  },
  {
    question: 'Will the ads play beyond Spotify?',
    answer:
      'Yes, Ads by Anchor can play on and beyond Spotify. Ads served to listeners on Spotify will be delivered via Spotify’s proprietary Streaming Ad Insertion technology, which enables the most precise and transparent podcast advertising in the industry. Creators are also paid at a higher rate for ads served on Spotify.',
  },
  {
    question: 'Can I use multiple monetization tools at the same time?',
    answer:
      'Creators are free to choose how many ads, and which types (based on which they qualify for), to include in their episodes, to maximize their earning potential. However, we recommend that you not include ads in episodes for your subscribers.',
  },
  {
    question: 'How much can I earn?',
    answer: 'Earnings vary depending on the sponsor and your audience.',
  },
];

export { FAQS };
